import React from 'react'
import MaterialSymbol from '../material-symbol'

const Reply = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="reply" {...props} />
))

Reply.displayName = 'Reply'

export default Reply
